var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgActiveUsers = function SvgActiveUsers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7778 16.4444V14.8889C10.7778 12.7411 9.03666 11 6.88889 11C4.74111 11 3 12.7411 3 14.8889V16.4444H10.7778ZM10.7778 16.4444H17V15.6667C17 13.3757 15.2589 11.7778 13.1111 11.7778C12.0119 11.7778 11.0191 12.2643 10.3118 13.0464M9.22222 6.33333C9.22222 7.622 8.17755 8.66667 6.88889 8.66667C5.60022 8.66667 4.55556 7.622 4.55556 6.33333C4.55556 5.04467 5.60022 4 6.88889 4C8.17755 4 9.22222 5.04467 9.22222 6.33333ZM14.6667 7.88889C14.6667 8.748 13.9702 9.44444 13.1111 9.44444C12.252 9.44444 11.5556 8.748 11.5556 7.88889C11.5556 7.02978 12.252 6.33333 13.1111 6.33333C13.9702 6.33333 14.6667 7.02978 14.6667 7.88889Z",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgActiveUsers;